import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import {
  getCommerceIcons,
  getInitialLoadIcons,
  getLikeDislikeIcons,
  getNewIcons,
  getOtherIcons,
  getZee5PlayerIcons
} from 'src/styles/font';
import { flex } from 'src/styles/utils';
import {
  IconsSetType,
  Zee5PlayerIconsSet
} from 'src/utils/constants/IconsConstants';

import { MediaBP as MQ } from '../../../../../styles/mediaQuery';

export const button = (fromThumbnail = false, dislikeButton = false) => css`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 20px 8px 16px;
  gap: ${dislikeButton ? '0px' : '4px'};
  background: transparent;
  border: 1px solid ${colors.white};
  border-radius: 6px;
  cursor: pointer;
  ${fromThumbnail
    ? `color: ${colors.black};
    &:hover {
      color: ${colors.Purple};
      transition: background-color 0.25s ease-in,
        bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), color 0.25s ease-in,
        bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
     }`
    : `color: ${colors.white}`}
`;

export const likeAnimation = css`
  position: relative;
  &:before {
    content: '';
    position: absolute;
    width: 60px;
    height: 26px;
    left: 0px;
    background: url(/webapp-assets/images/Like_icon.gif);
    background-position: left;
    background-size: 84%;
  }
`;

const getIconLoadFunctionReference = (type: IconsSetType): any => {
  switch (type) {
    case IconsSetType.INITIAL_LOAD:
      return getInitialLoadIcons;
    case IconsSetType.NEW:
      return getNewIcons;
    case IconsSetType.OTHERS:
      return getOtherIcons;
    case IconsSetType.ZEE5_PLAYER:
      return getZee5PlayerIcons;
    case IconsSetType.LIKE_DISLIKE:
      return getLikeDislikeIcons;
    case IconsSetType.COMMERCE:
      return getCommerceIcons;
    default:
      return getInitialLoadIcons;
  }
};

export const iconStyle = (icon: any, type: IconsSetType) => css`
  width: 20px;
  height: 20px;
  font-size: ${icon === Zee5PlayerIconsSet.PLAY ? 16 : 20}px;
  ${flex()};
  color: ${colors.white};
  ${getIconLoadFunctionReference(type)(icon)};
`;
export const textStyle = css``;

export const disable = css`
  cursor: default;
  pointer-events: none;
  opacity: 0.5;
`;

export const detailsPageCtaWidth = css`
  width: calc(
    (175 / ${typeof window !== 'undefined' ? window.innerWidth : 360}) * 100vw
  );
  height: 32px;
  ${MQ.MediaSm} {
    height: 38px;
    width: 143px;
  }
  ${MQ.MediaMd} {
    width: 154px;
  }
  ${MQ.MediaLg} {
    width: 201px;
  }
  ${MQ.MediaXl} {
    height: 48px;
  }
`;

export const watchHistoryCss = css`
  width: 100%;
  ${MQ.MediaSm} {
    width: 305px;
  }
  ${MQ.MediaMd} {
    width: 325px;
  }
  ${MQ.MediaLg} {
    width: 420px;
  }
`;
